import React, { useEffect } from "react";
import AOS from "aos";
import Typewriter from "typewriter-effect";
import "aos/dist/aos.css";
import "./App.css";

function Edu() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <section className="edu-section">
      <div className="bg-animation"></div>

      {/* Header Section */}
      <div className="edu-header" data-aos="fade-up">
        <h2 data-aos="fade-up" data-aos-delay="0">Education & Experience</h2>
        <h3 data-aos="fade-up" data-aos-delay="200">Empowering Creativity</h3>
        <p data-aos="fade-up" data-aos-delay="400">through</p>

       <p className="quote" data-aos="fade-up" data-aos-delay="600">
  <Typewriter
    options={{
      strings: [
        "With the guidance of Sunil Sir, my professional journey is steadily climbing the ladder of success — moving in the right direction, toward the right goals.",
      ],
      autoStart: true,
      loop: false,        
      delay: 50,            
      deleteSpeed: 0,       
      pauseFor: 999999     
    }}
  />
</p>
      </div>

      {/* Box Container */}
      <div className="edu-box-container">
        <div className="edu-box" data-aos="fade-up" data-aos-delay="100">
          <h3>SSC</h3>
          <p className="year">2020-2021</p>
          <p>
            Yogiraj Shree Krishna Vidyalaya. SSC Maharashtra Board. Scored 79.40%
          </p>
        </div>
        <div className="edu-box" data-aos="fade-up" data-aos-delay="300">
          <h3>HSC</h3>
          <p className="year">2022-2023</p>
          <p>
            RJ College, Ghatkopar. HSC Maharashtra Board. Scored 76.83%
          </p>
        </div>
        <div className="edu-box" data-aos="fade-up" data-aos-delay="500">
          <h3>Internship</h3>
          <p className="year">2024</p>
          <p>
            3-month internship in Full Stack Web Dev. Learned React, Node, .NET
          </p>
        </div>
        <div className="edu-box" data-aos="fade-up" data-aos-delay="700">
          <h3>Degree</h3>
          <p className="year">2023 - Present</p>
          <p>
            Currently pursuing BSc IT. Focused on React, .NET & Software Projects
          </p>
        </div>
      </div>
    </section>
  );
}

export default Edu;
